import React from 'react';
import {IconBox, IconProps} from "./index";


import AiSvg from "../../../assets/icons/aiIcon.svg?react";


export const AiIcon: React.FC<IconProps> = (
    {
        size = 20,
        className
    }
) => {
    return (
        <IconBox
            size={size}
            className={className}
        >
            <AiSvg width={`${size}px`} height={`${size}px`}/>
        </IconBox>
    );
};
